import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import OverallProgressCard from '../common/OverallProgressCard';
import useReports from 'state/hooks/use-reports';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useTeachingOrder from 'state/hooks/use-teaching-order';

const t = (key: string, options?) => translate('reports', key, options);

const getOverallProgress = (progress, activeCharacters) => {
  return (
    progress?.reduce(
      (acc, curr) => {
        if (!curr) return acc;
        const isActiveCharacter = activeCharacters?.find((c) => c.id === curr.characterId);
        if (!isActiveCharacter) return acc;
        return {
          bookReadStudentCount: acc.bookReadStudentCount + (curr.bookReadStudentCount > 0 ? 1 : 0),
          activityTotalCount: acc.activityTotalCount + (curr.activityTotalCount ?? 0),
          activityCompletedCount: acc.activityCompletedCount + (curr.activityCompletedCount ?? 0),
          averageTimeSpent: 0,
          activitySkippedCount: acc.activitySkippedCount + (curr.activitySkippedCount ?? 0),
        };
      },
      {
        bookReadStudentCount: 0,
        activityTotalCount: 0,
        activityCompletedCount: 0,
        averageTimeSpent: 0,
        activitySkippedCount: 0,
      }
    ) ?? {}
  );
};

const OverallProgress: React.FC = () => {
  const classes = useStyles();
  const [{ charactersProgress }] = useReports();
  const [{ activeCharacters }] = useTeachingOrder();

  const progress = getOverallProgress(charactersProgress, activeCharacters);

  return (
    <Box component={Paper} padding={6} display="flex" flexDirection="column" gap={remCalc(12)}>
      <Typography className={classes.cardTitle}>{t('overallReporting')}</Typography>
      <OverallProgressCard progress={progress} />
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  cardTitle: {
    fontSize: remCalc(28),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
  buttonLinkIcon: {
    fontSize: remCalc(16),
    marginRight: remCalc(10),
  },
  buttonLinkText: {
    fontSize: remCalc(14),
    lineHeight: remCalc(20),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
}));

export default OverallProgress;
